<template>
  <div class="watermarked-page">
    <div style="width:1300px;margin:0 auto;" id="v-content" :style="{ minHeight: Height + 'px' }">
      <div class="card mb-5" style="box-shadow: 10px 10px 5px #888888;margin-top:20px;">
        <p class="mt-1 mb-1 p-1 font">
          <img src="../../../static/images/kucun.png" style="width:1.5rem;height:1.5rem;" class="mb-lg-1" alt="" />
          <span class="p-1"
            style="text-shadow:#000 1px 0 0;background-color:#3190e8;color:#fff;box-shadow: 6px 4px 9px #888888;font-family: Helvetica Neue,Tahoma,Arial;border-radius:3px;">
            产品查询
          </span>
          <span class="ml-5">
            总共有
            <span style="color:green;font-size:20px;">{{ total }}</span>
            条数据
          </span>
          <span class="ml-5">
            总共有
          </span>
          <span style="color:green;font-size:20px;">
            {{ Record }}
          </span>
          <span>
            页
          </span>
          <span class="float-right span_close"
            style="display:block;width:20px;line-height:20px;text-align:center;font-size:25px;" @click="$router.go(-1)">
            &times;
          </span>
        </p>
        <div class="mb-2" style="margin-left:20px;display:flex;align-items:center;">
          <span>药品名称:</span>
          <input type="text" class="input_form-control ml-lg-2" placeholder="请填入药品名称" v-model="searchForm.searchKey"
            @keydown.enter="searchEnterFun">
          <span class="ml-3">产地:</span>
          <input type="text" class="input_form-control ml-lg-2" placeholder="请填入产地" v-model="searchForm.searchKey2"
            @keydown.enter="searchEnterFun">
          <span class="ml-3">规格:</span>
          <input type="text" class="input_form-control ml-lg-2" placeholder="请填入规格" v-model="searchForm.searchKey3"
            @keydown.enter="searchEnterFun">
         <!-- <span class="ml-3">代理商:</span>
          <input type="text" class="input_form-control ml-lg-2" placeholder="请填入代理商" v-model="searchForm.searchKey4"
            @keydown.enter="searchEnterFun">-->
          <button class="bg-primary button_zi heit ml-3" @click="getClerkDrugQuery()">查询</button>
        </div>

        <div v-if="showPage">

          <table class="table table-striped table-hover" ref="print">
            <thead>
              <tr style="white-space: nowrap;">
                <th>药品名称</th>
                <th>产地名称</th>
                <th>规格</th>
                <th>仓库</th>
                <th>代理商</th>
                <th>包装</th>
                <th>中包装</th>
                <th>零/整</th>
                <th>库存</th>
                <th>进价</th>
                <th>价格</th>
                <th>单位</th>
                <th>批准文号</th>
                <th>批号</th>
                <th>生产日期</th>
                <th>有效期</th>
                <th>国家零售价</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in tableData" :key="index" class="row-with-watermark">
                <td @dblclick="onInputdrugName(index)">{{ item.ypmc }}</td>
                <td @dblclick="onInputcustomerName(index)">{{ item.cdmc }}</td>
                <td>{{ item.gg }}</td>
                <td>{{ item.ck }}</td>
                <td>{{ item.boss }}</td>
                <td>{{ item.bz }}</td>
                <td>{{ item.zbz }}</td>
                <td>{{ item.isretail | change }}</td>
                <td>{{ item.sl }}</td>
                <td>{{ item.jj }}</td>
                <td>{{ item.dj }}</td>
                <td>{{ item.dw }}</td>
                <td>{{ item.pzwh }}</td>
                <td>{{ item.ph }}</td>
                <td>{{ item.scrq }}</td>
                <td>{{ item.yxq }}</td>
                <td>{{ item.lsj }}</td>
              </tr>
            </tbody>
          </table>

          <div>
            <v-pagination :total="total" :current-page='current' @pagechange="pagechange"></v-pagination>
          </div>


        </div>

        <div v-else>

          <img src="../../../static/images/wushuju.jpg" style="width:300px;height:300px;display:block;margin:0 auto;"
            alt="">

        </div>

      </div>

    </div>
     <Watermark
      text="赵璇专用"
      fontSize="20px"
      color="rgba(255, 0, 0, 0.4)"
      rotate="-15"
      opacity="0.4"
    />
  </div>
</template>

<script>
import Loading from '../../components/Loading.vue'
import vPagination from "../../components/Pagination.vue";
import Watermark from '../../components/Watermark.vue'
import { async } from 'q';
export default {
  name: 'DrugQuery',
  data() {
    return {
      Height: 0,
      searchForm: {
        searchKey: '',
        searchKey2: '',
        searchKey3: '',
        searchKey4: '',
      },//搜索内容
      searchData: [],//搜索返回的清单
      isLoading: false,
      showPage: true,
      tableData: [],
      Record: '',//总记录数
      Pcount: '',//总页数
      PageNo: 1, //当前页码

      total: 1,     // 记录总条数
      display: 20,   // 每页显示条数
      current: 1,   // 当前的页数

    }
  },
  components: {
    vPagination,
    Loading,
    Watermark
  },
  computed: {

  },
  filters: {
    change(data) {
      if (data == 1) {
        return "零"
      } else {
        return '整'
      }
    }
  },

  methods: {
    // 禁用F12和右键等操作
    disableDevTools() {
      // 禁用F12键
      document.addEventListener('keydown', (e) => {
        if (e.key === 'F12') {
          e.preventDefault();
          return false;
        }

        // 禁用Ctrl+Shift+I (开发者工具)
        if (e.ctrlKey && e.shiftKey && e.key === 'I') {
          e.preventDefault();
          return false;
        }

        // 禁用Ctrl+Shift+J (控制台)
        if (e.ctrlKey && e.shiftKey && e.key === 'J') {
          e.preventDefault();
          return false;
        }

        // 禁用Ctrl+U (查看源代码)
        if (e.ctrlKey && e.key === 'u') {
          e.preventDefault();
          return false;
        }

        // 禁用Shift+F10 (上下文菜单)
        if (e.shiftKey && e.key === 'F10') {
          e.preventDefault();
          return false;
        }
      });

      // 禁用右键菜单
      document.addEventListener('contextmenu', (e) => {
        e.preventDefault();
        return false;
      });

      // 监控开发者工具的打开（通过检测控制台输出变化）
      let devtools = {
        open: false,
        orientation: null
      };

      const threshold = 160;

      setInterval(() => {
        if (window.outerHeight - window.innerHeight > threshold ||
            window.outerWidth - window.innerWidth > threshold) {
          if (!devtools.open) {
            devtools.open = true;
            // 可以在这里添加额外的处理逻辑
            console.log('开发者工具已打开');
          }
        } else {
          devtools.open = false;
        }
      }, 500);
    },

    //分页
    pagechange: function (currentPage) {
      this.getClerkDrugQuery(currentPage);
    },
    searchEnterFun(e) {
      var keyCode = window.event ? e.keyCode : e.which;
      if (keyCode == 13) {
        this.getClerkDrugQuery();
      }
    },

    onInputdrugName: function (index) {
      if (this.searchData.length > 0) {
        this.searchForm.searchKey = this.searchData[index].ypmc;
      }
      else {
        this.searchForm.searchKey = this.tableData[index].ypmc;
      }
    },
    onInputcustomerName: function (index) {
      if (this.searchData.length > 0) {
        this.searchForm.searchKey2 = this.searchData[index].cdmc
      }
      else {
        this.searchForm.searchKey2 = this.tableData[index].cdmc;
      }
    },

    getClerkDrugQuery: async function (PageIndex) {
      const that = this
      that.isLoading = true;
      if (!PageIndex) { PageIndex = 1 }
      that.PageNo = PageIndex || that.PageNo
      const { data: res } = await that.$http.post('Dls/getFun', {
        action: 'ClerkDrugsQueryTests',
        obj: JSON.stringify({
          SearchKey: '',
          PageIndex,
          SearchKey: that.searchForm.searchKey,
          SearchKey2: that.searchForm.searchKey2,
          SearchKey3: that.searchForm.searchKey3,
          ipcode: localStorage.getItem("ipcode"),
          searchKey4: that.searchForm.searchKey4,
        })
      })
      // console.log(res)
      if (res.isok) {
        if (res.data.isok) {
          const obj = res.data;
          if (obj.rows2 == null) {
            that.tableData = []
            that.Pcount = 0
            that.Record = 0
            that.total = 0
            this.showPage = false;
            that.isLoading = false;
            return;
          }
          that.tableData = obj.rows2
          if (that.tableData.length > 0) {
            that.showPage = true;
          }
          else {
            that.showPage = false;
          }
          that.Record = obj.record
          that.total = obj.pcount
          that.Pcount = obj.pcount
          that.isLoading = false;

        }
        else {
          alert(res.data.msg);
        }
      }
      else {
        alert(res.message);
      }

    },

  },
  mounted() {
    this.Height = document.documentElement.clientHeight - 100;
    window.onresize = () => {
      this.Height = document.documentElement.clientHeight - 100
    };
  },
  created() {
    // 禁用开发者工具
    this.disableDevTools();
    this.getClerkDrugQuery();
  }
}
</script>

<style scoped>
.table-hover>tbody>tr:hover {
  background-color: #dee2e6 !important;
}

.font {
  font-size: 15px;
}

.font_yz {
  font-size: 1px;
  color: red;
}

.button_zi {
  text-shadow: #000 1px 0 0;
  border-radius: 5px;
  border: none;
  color: azure;
}

.heit {
  height: 1.5rem;
}

.span_close:hover {
  color: #3190e8;
}

.input_form-control {
  /* // display: block;  */
  width: 15%;
  height: 24px;
  padding: 6px 12px;
  font-size: 14px;
  line-height: 1.428571429;
  color: #555555;
  vertical-align: middle;
  background-color: #ffffff;
  border: 1px solid #cccccc;
  border-radius: 4px;
  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
  -webkit-transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;
  transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;
}

.input_form-control:focus {
  border-color: #66afe9;
  outline: 0;
  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075), 0 0 8px rgba(102, 175, 233, 0.6);
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075), 0 0 8px rgba(102, 175, 233, 0.6);
}

.input_form-control:disabled {
  border: 1px solid #DDD;
  background-color: #F5F5F5;
  color: #ACA899;
  opacity: 1;
}


</style>



// WEBPACK FOOTER //
// src/pages/Lihui/ZxInventory.vue